var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 42",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Arrows with Dollar Sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m23.3 21l1.3-10.6c1.4 0.3 2.7 1 3.7 1.5l1-1.7c-1.2-0.7-2.7-1.4-4.5-1.8l0.4-3.6-2-0.2-0.4 3.6h-0.1c-3.9 0-7.6 3.2-7.6 6.5 0 3 2 5.5 6.1 7.4l-1.4 11.6c-1.7-0.3-2.9-1-4-1.6l-0.2-0.1-1 1.7 0.2 0.1c1.2 0.7 2.7 1.5 4.8 1.9l-0.4 3.5 2 0.2 0.4-3.6h0.1c4.3 0 8.7-2.6 8.7-7 0-3.5-1.9-5.6-7.1-7.8m-6.2-6.2c0-2.2 2.7-4.5 5.4-4.5l-1.1 9.8c-2.9-1.5-4.3-3.2-4.3-5.3m4.7 19.1l1.3-10.8c4.4 2 5.2 3.5 5.2 5.8 0 3.4-3.8 5-6.5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,13.5H3.5c4.4-5.5,9-11.2,19-11.2c11.1,0,20.1,9,20.1,20.2h2.2c0-12.4-10-22.4-22.3-22.4  C11.8,0.1,6.7,6,2.3,11.5v-8H0.1v12.3h12.3V13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    colorInterpolationFilters: "st0",
    d: "m32.5 31.5h7.8 1c-4.4 5.5-9 11.2-19 11.2-11 0-20-9-20-20.2h-2.2c0 12.4 10 22.4 22.3 22.4 10.7 0 15.9-5.9 20.3-11.4v8.1h2.2v-12.4h-12.4v2.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/Transactions_Icon.5a885e8edc07485cb089743fe482499c.svg";
export { ForwardRef as ReactComponent };